import { Box, Typography } from '@mui/material'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { localizeEmobilityNumber } from '../utils/localize-emobility-number'

interface ChargingSessionsSolarRatioComponentProps {
  ratio: number
}

/** Component to illustrate the percentage of the solar ratio in a more user-friendly manner. */
export const ChargingSessionsSolarRatioComponent: React.FC<ChargingSessionsSolarRatioComponentProps> = ({ ratio }): JSX.Element => {
  const { t } = useCustomTranslation()

  const localizedRatio = t('common.format.percentageValue', '', {
    value: localizeEmobilityNumber(ratio),
  })

  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: '#B3E6FA',
        border: '3px solid #606161',
        height: '42px',
        boxSizing: 'content-box',
        overflow: 'hidden',
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: `${Math.round(ratio)}%`,
          backgroundColor: '#C9DBAE',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box component={'span'} pl={'10px'} whiteSpace="nowrap">
          {localizedRatio}
        </Box>
      </Typography>
    </Box>
  )
}
